module.exports = __webpack_public_path__ + "img/relatorioFill.f9be23ba.svg";